import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
  Spinner,
} from '@herit-fe/heritage-ui';
import type { ReactNode } from 'react';

/**
 * 2-way 확인 다이얼로그(공통) — heritage `AlertDialog` + outline 취소 + (파괴적) 확인. pending 중 닫기·버튼 잠금
 * + Spinner. 삭제·해지 등 동형 확인을 흡수. 성공 토스트·mutation 은 호출처(feature)가 `onConfirm` 에서 소유.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  pending = false,
  destructive = false,
  confirmDisabled = false,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  confirmLabel: ReactNode;
  cancelLabel: ReactNode;
  onConfirm: () => void;
  /** 진행 중(mutation isPending) — 닫기·버튼 잠금 + 확인에 Spinner. */
  pending?: boolean;
  /** 파괴적 액션(삭제 등) — 확인 버튼 destructive 변형. */
  destructive?: boolean;
  /** 확인 버튼 추가 비활성(예: 임시 비번 미생성). */
  confirmDisabled?: boolean;
}) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !pending && onOpenChange(next)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {/* 항상 렌더(빈 description 도 element 유지) — base-ui a11y Description 보존·닫힘 시 언마운트 경고 회피. */}
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel variant="outline" disabled={pending}>
            {cancelLabel}
          </AlertDialogCancel>
          <Button
            variant={destructive ? 'destructive' : 'default'}
            onClick={onConfirm}
            disabled={pending || confirmDisabled}
          >
            {pending ? <Spinner className="size-4" /> : confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
